<template>
	<div>
		<BaseTabBar
			v-model="tabActiveAtIndex"
		>
			<CTab title="All branches">
				<!-- render when tab index equal 0 -->
				<StockBrowserBranchList
					v-if="tabActiveAtIndex === 0"
				/>
			</CTab>
			<CTab title="All SKU">
				<!-- render when tab index equal 1 -->
				<StockBrowserSkuList
					v-if="tabActiveAtIndex === 1"
				/>
			</CTab>
		</BaseTabBar>
	</div>
</template>

<script>
import { cleanObject, cloneDeep } from '../helpers/utils';

// Constant tabs, use with BaseTabBar component and  methods
const TABS = Object.freeze({
	0: 'branch',
	1: 'sku',
});

export default {
	name: 'StockBrowser',

	data() {
		return {
			tabActiveAtIndex: this.getTabIndex(this.$route.query.tab),
			params: {
				tab: this.$route.query.tab,
			},
		};
	},

	watch: {
		tabActiveAtIndex() {
			this.params.tab = TABS[this.tabActiveAtIndex];
		},
		params: {
			handler() {
				this.updateUrl();
			},
			deep: true,
		},
	},

	methods: {
		getTabIndex(tabValue) {
			const index = Object.values(TABS).findIndex((value) => value === tabValue);

			return index === -1
				? 0 // default as 0
				: index;
		},
		updateUrl() {
			const query = cleanObject(cloneDeep(this.params));
			this.$router.push({ query }).catch(() => {});
		},
	},
};
</script>